// @flow
/* eslint-disable no-template-curly-in-string */

export default {
  All: 'كل',
  AllDocuments: 'جميع الوثائق',
  Any: 'أي',
  Today: 'اليوم',
  Yesterday: 'أمس',
  LastWeek: 'الأسبوع الماضي',
  LastMonth: 'الشهر الماضي',
  DateFrom: 'من',
  DateTo: 'ل',
  DateRange: 'النطاق الزمني',
  NeverViewed: 'لم يتم عرضها أو تغييرها منذ آخر عرض',
  AddedLastLogin: 'تمت الإضافة أو التغيير منذ آخر تسجيل دخول',
  GlobalNetworkErrorMessage:
    'هناك مشكلة في الشبكة. حاول مرة أخرى أو اتصل بالدعم.',
  GlobalIntermediateProxyErrorMessage:
    'اعترضت شبكتك هذا الطلب إلى غرفة البيانات. اتصل بقسم تكنولوجيا المعلومات لديك.',
  GlobalUnexpectedErrorWithIdMessage:
    'هناك مشكلة في غرفة البيانات الخاصة بك.  اقتبس هذا الرمز \u003c[ErrorId]\u003eلفريق خدمة العملاء لدينا.',
  GlobalUnexpectedErrorMessage:
    'هناك مشكلة في غرفة البيانات الخاصة بك.  يرجى الاتصال بفريق خدمة العملاء لدينا.',
  NoRecordsFound: 'لم يتم العثور على سجلات.',
  Save: 'أنقذ',
  Print: 'طبع',
  ViewAs: 'عرض ك',
  Documents: 'الوثائق',
  Date: 'تاريخ',
  HideEmptyFolders: 'إخفاء المجلدات الفارغة',
  Search: 'بحث',
  Actions: 'الاجراءات',
  Filter: 'راووق',
  Self: 'أنت',
  Allowed: 'سمح',
  Denied: 'نفي',
  PleaseEnterValidToDate: 'الرجاء إدخال تاريخ صالح.',
  PleaseEnterValidFromDate: 'الرجاء إدخال تاريخ صالح.',
  SavingAllowed: 'التوفير مسموح به',
  SavingDenied: 'رفض الادخار',
  PrintingAllowed: 'الطباعة مسموح بها',
  PrintingDenied: 'تم رفض الطباعة',
  ChooseLanguage: 'اختر اللغة',
  EditProfile: 'تحرير الملف الشخصي',
  DataRooms: 'غرف البيانات',
  Administration: 'إدارة',
  MyAccount: 'حسابي',
  Profile: 'ملف تعريف',
  Logout: 'الخروج',
  Loading: 'تحميل',
  Success: 'نجاح',
  Disabled: 'ذوي الاحتياجات الخاصه',
  Ok: 'موافق',
  And: 'و',
  Demo: 'عرض',
  TenderSubmissionsStart: 'ابدأ عملية التقديم',
  TenderSubmissionsOverdue:
    'انتهت عملية التقديم. سيتم وضع علامة على المستندات التي تقوم بتحميلها الآن على أنها متأخرة.',
  TenderSubmissionsClose: 'انتهت عملية التقديم.',
  Later: 'فيما بعد',
  StartNow: 'ابدأ الآن',
  StartSubmissionDialogTitle: 'ابدأ عملية التقديم',
  StartSubmissionDialogContent:
    'سيتم إخطار مقدمي العطاءات بأنه يمكنهم تحميل المستندات وعرضها. ' +
    'لا يمكن لفرقك الداخلية الوصول إلى المستندات أثناء عملية الإرسال.',
  StartSubmissionDialogCloseDateContent: 'تنتهي عملية التقديم في ${closeDate}.',
  SubmissionInformationIsIncomplete: 'معلومات التقديم غير كاملة. ',
  BidderTeamsHaveNotBeenInvitedOrHaveBeenRemoved:
    'لم تتم دعوة مقدمي العطاءات أو تمت إزالتهم. ',
  InviteBidderTeams: 'دعوة مقدمي العروض',
  UpdateSecuritySettings: 'تحديث إعدادات الأمان',
  UpdateTheirSecuritySettings: 'قم بتحديث إعدادات الأمان الخاصة بهم.',
  OnTimeSubmission: 'التقديم في الوقت المحدد',
  LateSubmission: 'التأخر في تقديم التقارير',
  DeleteAllDocuments: 'حذف جميع مستندات التقديم',
  Manage: 'أدار',
  ManageSubmissions: 'إدارة عمليات الإرسال',
  NotStarted: 'لم يبدأ',
  Closed: 'مغلق',
  ExtraTime: 'في الوقت الإضافي',
  Open: 'مفتوح',
  CreateTheStructureAndSetTheCloseDateForBidderSubmissions:
    'إنشاء الهيكل وتحديد تاريخ الإغلاق لتقديم العطاءات.',
  AddSubmissionWindow: 'إضافة نافذة إرسال',
  BiddersDoNotHaveAccessToAddSubmissionsSingular:
    '1 لا يملك المزايد حق الوصول لإضافة عمليات الإرسال.',
  BiddersDoNotHaveAccessToAddSubmissionsPlural:
    'لا يملك ${totalBidders} مقدمي العطاءات حق الوصول لإضافة عمليات الإرسال.',
  BulkRedactionCurrentDocumentNumberOfTotal:
    '${currentDocumentNumber} الوثائق ${totalDocsCount}',
  BulkRedactionMarksToRedact: '${selectedMarksCount} العناصر المراد تنقيحها',
  BulkRedactionMarksRedacted: '${redactionMarksCount} العناصر المنقحة',
  BulkRedactionSkipAndNext: 'تخطي المستند',
  BulkRedactionSkipAndFinish: 'تخطي وإنهاء التنقيح',
  BulkRedactionSaveAndNext: 'حفظ والمستند التالي',
  BulkRedactionSaveAndFinish: 'حفظ وإنهاء التنقيح',
  BulkRedactionRedactAllRemainingDocuments:
    'تنقيح جميع المستندات ${documentsRemaining}',
  BulkRedactionCancel: 'إلغاء الأمر',
};
